import React from "react";
import { Link, useHistory } from "react-router-dom";
import DataTable from "../core/ui/data-table";
import FormatDateTime from "../core/utils/FormatDateTime";

export default function AdminSystemErrorLogs() {
  const history = useHistory();

  const table_columns = [
    { header: "User", key: "first_name", render: (val) => val.user.first_name + " " + val.user.last_name },
    { header: "Company", key: "name", render: (val) => val.company.name },
    // { header: "IP Address", key: "ip_address" },
    { header: "Call Time", key: "error_timestamp", render: (val) => <FormatDateTime date={val.error_timestamp} /> },
    { header: "API Being Called", key: "api_called", render: (val) => val.api_called.replace(/^\/v1\//, '') || "" },
    // { header: "Payload of Call (JSON Object)", key: "payload", render: (val) => val.payload || "N/A" },
    // { header: "Error Returned", key: "error_returned", render: (val) => val.error_returned || "N/A" },
    { header: "Response Code", key: "response_code" },
    { header: "Response Text", key: "response_text" },
  ];

  const table_actions = (item) => (
    <ul id="action-menu" className="action-menu">
      <Link to={"/admin-error-log-details#error_id=" + item.id}>
        {" "}<i className="bi bi-eye"></i>Details
      </Link>
    </ul>
  );

  function onClickAdmin(ev) {
    ev.stopPropagation();
    history.push("/admin");
  }

  return (
    <div className="page admin-page">
      <div className="list-header sticky-page-header">
        <button className="new-button" onClick={onClickAdmin}>
          <i className="bi bi-chevron-left"/> Admin
        </button>
        <h1>System Error Logs</h1>
        <i className="spacer" />
      </div>
      <div>
        <DataTable
          query="admin/error_logs"
          cols={table_columns}
          actions={table_actions}
          empty="No Logs Found"
        />
      </div>
    </div>
  );
}
